import React, { useEffect, useState } from 'react';
import '../../../custom.css'
import {
    Container, Row, Col, DropdownMenu, DropdownItem, UncontrolledDropdown, DropdownToggle
} from "reactstrap";
import { Message } from 'primereact/message';
import { PlayersDropdown } from '../../dropdowns/PlayersDropdown';
import { RoundTypeDropdown } from '../../dropdowns/RoundTypeDropdown';
import { DurationDropdown } from '../../dropdowns/DurationDropdown';
import { Scorecard } from '../../Scorecard';
import { IndividualStats } from './IndividualStats';
import { useAuth } from "../../appwrite-testing/AuthContext";
import { DateInput } from '../../DateInput';


export function StatsPage({ areIndividualStats }) {
    const [round, setRound] = useState(null);
    const { user, getJWT } = useAuth();
    const userId = user?.$id || "000000";

    const [selectedUserId, setSelectedUserId] = useState(0);
    const [selectedUser, setSelectedUser] = useState(null);
    
    const [roundType, setRoundType] = useState("All");
    const [custom, setCustom] = useState(false);
    const [selectTournament, setSelectTournament] = useState(false);
    const [tournament, setTournament] = useState("tournament");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    var [durationType, setDurationType] = useState('number');
    var [timeDuration, setTimeDuration] = useState('');
    var [numberOfRounds, setNumberOfRounds] = useState(10);
    const roundTypes = ["All", "Tournament", "Qualifying", "Practice"];
    const listTournaments = ["tournament1", "tournament2"];
    const [bottom10, setBottom10] = useState(false);
    const [top20, setTop20] = useState(false);
    const durations = ["Last Round", "Last 3 Rounds", "Last 4 Rounds", "Last 10 Rounds", "Last 15 Rounds",
        "Last 20 Rounds", "Last 30 Rounds", "Last Month", "Last 3 Months", "Last 6 Months", "Last 12 Months", "This year", "Fall", "Spring", "Custom"];

    const [data, setData] = useState(null);
    const [baseline, setBaseline] = useState("");
    const [userUnits, setUserUnits] = useState("");
    const [roundsFound, setRoundsFound] = useState(true);
    const [requestProcessed, setRequestProcessed] = useState(false);
    const [coachTeam, setCoachTeam] = useState(window.localStorage.getItem("team"))

    function fillOutTable(data) {
        setData(data);
    }

    function getRounds(durationType, timeDuration, numberOfRounds, roundType) {
        if (areIndividualStats) {
            getSelectedRounds(durationType, timeDuration, numberOfRounds, roundType)
        } else {
            getMyRounds(durationType, timeDuration, numberOfRounds, roundType);
            if (durationType.toLowerCase() === "number" && numberOfRounds === 1) {
                getRoundShots(roundType)
            }
        }
    }

    async function getRoundShots(roundType) {
        try {
            const jwt = await getJWT();
            const response = await fetch(`/api/Round/user-last?numberOfRounds=${1}&userId=${userId}&roundType=${roundType}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${jwt}`
                },
            });
            const data = await response.json();
            setRound(data[0]);
        } catch (error) {
            console.error(error);
        }
    }

    async function getMyRounds(durationType, timeDuration, numberOfRounds, roundType) {
        setRequestProcessed(false);
        try {
            const jwt = await getJWT();
            let url;
            
            if (durationType.toLowerCase() === "time") {
                url = `/api/Calculation/user-last-duration?timeType=month&duration=${timeDuration}&userId=${userId}&roundType=${roundType}`;
            } else if (durationType.toLowerCase() === "number") {
                url = `/api/Calculation/user-last?numberOfRounds=${numberOfRounds}&userId=${userId}&roundType=${roundType}`;
            } else if (durationType.toLowerCase() === "custom" && startDate !== null && endDate !== null) {
                url = `/api/Calculation/user-date-range?startDate=${startDate.toISOString().substring(0, 10)}&endDate=${endDate.toISOString().substring(0, 10)}&userId=${userId}&roundType=${roundType}`;
            } else if (durationType.toLowerCase() === "fall") {
                url = `/api/Calculation/user-date-range?startDate=${"2024-08-25"}&endDate=${"2024-11-01"}&userId=${userId}&roundType=${roundType}`;
            } else if (durationType.toLowerCase() === "spring") {
                url = `/api/Calculation/user-date-range?startDate=${"2023-02-10"}&endDate=${"2023-05-01"}&userId=${userId}&roundType=${roundType}`;
            } else if (durationType.toLowerCase() === "this year") {
                url = `/api/Calculation/user-date-range?startDate=${"2024-01-01"}&endDate=${"2024-12-31"}&userId=${userId}&roundType=${roundType}`;
            }

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${jwt}`
                },
            });
            
            const data = await response.json();
            setRoundsFound(true);
            setRequestProcessed(true);
            fillOutTable(data);
        } catch (error) {
            console.error(error);
            setRoundsFound(false);
            setRequestProcessed(true);
        }
    }

    async function getSelectedRounds(durationType, timeDuration, numberOfRounds, roundType) {
        setRequestProcessed(false);
        try {
            const jwt = await getJWT();
            let url;
            
            if (durationType.toLowerCase() === "time") {
                url = `/api/Calculation/user-last-duration?timeType=month&duration=${timeDuration}&userId=${selectedUserId}&roundType=${roundType}`;
            } else if (durationType.toLowerCase() === "number") {
                url = `/api/Calculation/user-last?numberOfRounds=${numberOfRounds}&userId=${selectedUserId}&roundType=${roundType}`;
            } else if (durationType.toLowerCase() === "custom" && startDate !== null && endDate !== null) {
                url = `/api/Calculation/user-date-range?startDate=${startDate.toISOString().substring(0, 10)}&endDate=${endDate.toISOString().substring(0, 10)}&userId=${selectedUserId}&roundType=${roundType}`;
            } else if (durationType.toLowerCase() === "fall") {
                url = `/api/Calculation/user-date-range?startDate=${"2024-08-25"}&endDate=${"2024-10-29"}&userId=${selectedUserId}&roundType=${roundType}`;
            } else if (durationType.toLowerCase() === "spring") {
                url = `/api/Calculation/user-date-range?startDate=${"2023-02-10"}&endDate=${"2023-05-01"}&userId=${selectedUserId}&roundType=${roundType}`;
            } else if (durationType.toLowerCase() === "this year") {
                url = `/api/Calculation/user-date-range?startDate=${"2024-01-01"}&endDate=${"2024-12-31"}&userId=${selectedUserId}&roundType=${roundType}`;
            }

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${jwt}`
                },
            });
            
            const data = await response.json();
            setRoundsFound(true);
            setRequestProcessed(true);
            fillOutTable(data);
        } catch (error) {
            console.error(error);
            setRoundsFound(false);
            setRequestProcessed(true);
        }
    }

    useEffect(() => {
        if (selectedUser)
            setBaseline(selectedUser.baseline);
    }, [selectedUser])

    useEffect(() => {
        if (!areIndividualStats) {
            var baseline = window.localStorage.getItem("baseline");
            if (baseline) {
                setBaseline(baseline);
            } else {
                fetch(`/api/User/userBaseline?userId=${userId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                })
                    .then(response => {
                        return response.text();
                    })
                    .then(data => {
                        setBaseline(data);
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
        }
    }, [])

    useEffect(() => {
        setData(null);

        getRounds(durationType, timeDuration, numberOfRounds, roundType);
    }, [durationType, timeDuration, numberOfRounds, roundType, startDate, endDate, custom, selectedUserId]);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const jwt = await getJWT();
                const response = await fetch(`api/user/myself?userId=${user.$id}`, {
                    headers: {
                        'Authorization': `Bearer ${jwt}`,
                    },
                });
                const responseData = await response.json();
                setUserUnits(responseData.units);
            } catch (error) {
                console.error(error);
            }
        }

        const units = window.localStorage.getItem("units");
        const team = window.localStorage.getItem("team");
        if (units && team) {
            setUserUnits(units);
            setCoachTeam(team);
        } else {
            fetchUser();
        }
    }, [user]);

    function renderFilters() {
        if (!custom && !selectTournament) {
            return (
                <div >
                    <Row >
                        <Col xs="6" sm="4" md="3" lg="3">
                            <RoundTypeDropdown setRoundType={setRoundType} roundType={roundType} roundTypes={roundTypes} setTournamentSelected={() => console.log()} />
                        </Col>
                        <Col xs="6" sm="2" md="2" lg="1">
                            <DurationDropdown setNumberOfRounds={setNumberOfRounds}
                                setTimeDuration={setTimeDuration} setCustom={setCustom}
                                setDurationType={setDurationType} durations={durations} />
                        </Col>
                        <Col className='mt-3 mt-md-0' xs={{ offset: 0, size: 5 }} sm={{ offset: 2, size: 5 }} md="2" lg="2">
                            {areIndividualStats &&
                                <PlayersDropdown setSelectedUserId={setSelectedUserId} setSelectedUser={setSelectedUser} selectedUser={selectedUser} coachTeam={coachTeam} />
                            }
                        </Col>
                    </Row>
                </div >
            )
        } else if (custom) {
            return (
                <div >
                    <Row>
                        <Col xs="8" md="2" lg="2">
                            <RoundTypeDropdown setRoundType={setRoundType} setSelectedUser={setSelectedUser} roundType={roundType} roundTypes={roundTypes} setTournamentSelected={() => console.log()} />
                        </Col>
                        <Col lg="8">
                            <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                                <label htmlFor='startDate'>Start Date</label>
                                <DateInput id="startDate" selectedDate={startDate} setSelectedDate={setStartDate} />
                                <label htmlFor='endDate'>End Date</label>
                                <DateInput id="endDate" selectedDate={endDate} setSelectedDate={setEndDate} />
                            </div>
                        </Col>

                        {areIndividualStats && <Col className='mt-0 mt-sm-3'>
                            <PlayersDropdown setSelectedUserId={setSelectedUserId} setSelectedUser={setSelectedUser} selectedUser={selectedUser} />

                        </Col>
                        }

                    </Row>
                </div>
            )
        } else if (selectTournament) {
            return (
                <div>
                    <Row>
                        <Col xs="3" md="2" lg="2">
                        </Col>
                        <Col xs="8" md="2" lg="2">
                            <UncontrolledDropdown value={roundType}>
                                <DropdownToggle
                                    caret
                                    color="primary">
                                    {tournament}
                                </DropdownToggle>
                                <DropdownMenu>
                                    {listTournaments.map((tour) => (
                                        <DropdownItem key={tour} value={tour} onClick={(event) => setTournament(event.target.value)}>
                                            {tour}
                                        </DropdownItem>
                                    ))}
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </Col>
                        {areIndividualStats && <Col>
                            <PlayersDropdown setSelectedUserId={setSelectedUserId} setSelectedUser={setSelectedUser} selectedUser={selectedUser} />
                        </Col>}
                    </Row>
                </div>
            )
        }
    }
    return (
        <Container>
            <div className='table-responsive'>
                {round && durationType.toLowerCase() === "number" && numberOfRounds === 1 && <Scorecard round={round} />}
            </div>
            {renderFilters()}
            {areIndividualStats ? selectedUser === null && <Message className='m-1 m-sm-3' severity="warn" text="No player was selected" />
                : ""}
            {!roundsFound && <Message className='m-1 m-sm-3' severity="warn" text="No rounds found" />}
            <IndividualStats data={data} baseline={baseline} requestProcessed={requestProcessed} units={userUnits} />
        </Container>
    )
};